const DATE_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
} as const satisfies Intl.DateTimeFormatOptions;

const DATE_TIME_OPTIONS = {
  ...DATE_OPTIONS,
  hour: 'numeric',
  minute: '2-digit',
} as const satisfies Intl.DateTimeFormatOptions;

export type FormatDateOptions = { timeZone?: string };

function toDate(value: string | Date): Date {
  return typeof value === 'string' ? new Date(value) : value;
}

export function formatUtcDate(value: string | Date): string {
  return toDate(value).toLocaleDateString('en-US', { ...DATE_OPTIONS, timeZone: 'UTC' });
}

export function formatUtcDateTime(value: string | Date): string {
  return toDate(value).toLocaleString('en-US', { ...DATE_TIME_OPTIONS, timeZone: 'UTC' });
}

export function formatLocalDate(value: string | Date, options: FormatDateOptions = {}): string {
  return toDate(value).toLocaleDateString('en-US', { ...DATE_OPTIONS, timeZone: options.timeZone });
}

export function formatLocalDateTime(value: string | Date, options: FormatDateOptions = {}): string {
  return toDate(value).toLocaleString('en-US', {
    ...DATE_TIME_OPTIONS,
    timeZone: options.timeZone,
  });
}
